import useSWR, { SWRResponse } from "swr";
import { IUseSelectedUserPoaForLoggedInUser } from "./types";
import commonSwrConfig from "../commonSwrConfig";
import useSelectedPowerOfAttorney from "../useSelectedPowerOfAttorney";
import { IPoaInfo } from "@portal/types/api/IPoaInfo";
import { useSession } from "@portal/auth/client/SessionProvider";
import { commonFetcher } from "../common/commonFetcher";

const useSelectedUserPoaForLoggedInUser: IUseSelectedUserPoaForLoggedInUser = () => {
  const { update } = useSession();
  const { data: selectedUser } = useSelectedPowerOfAttorney();

  const { data, error, isLoading }: SWRResponse<IPoaInfo[], unknown> = useSWR(
    selectedUser?.userId ? "/api/power-of-attorney/logged-in-user" : null,
    commonFetcher<IPoaInfo[]>,
    commonSwrConfig(update),
  );
  return {
    data,
    selectedUser,
    isLoading,
    error,
  };
};
export default useSelectedUserPoaForLoggedInUser;
